import { stylesFactory } from '@orthly/ui-primitives';

export const useInvoiceStyles = stylesFactory(theme => ({
    tableHeader: {
        [theme.breakpoints.down('lg')]: {
            marginTop: 56,
        },
    },
}));
